import { TagList } from '@brandbank/portal-components';
import { Typography } from '@mui/material';
import { useGetPurposeIntents } from '../api';
import PurposeIntentListSuccess from './PurposeIntentListSuccess';
import useUser from 'hooks/useUser';

type PurposeIntentListProps = {
  purposeId: string;
  purposeSubcode: string;
};

const PurposeIntentList = ({
  purposeId,
  purposeSubcode,
}: PurposeIntentListProps) => {
  const { hasRole } = useUser();

  const { data, status } = useGetPurposeIntents(purposeId);
  const canEditPurposeIntents = hasRole('Manage Purposes', purposeSubcode);

  const noDisplay = !data?.intentTags.length && !canEditPurposeIntents;

  return (
    <>
      {status === 'success' && (
        <PurposeIntentListSuccess
          purposeIntents={data.intentTags}
          purposeId={purposeId}
          canEdit={canEditPurposeIntents}
          sx={{
            '.tag-list-container': {
              paddingTop: noDisplay ? '0' : '8px',
            },
          }}
        />
      )}

      {status === 'loading' && <TagList value={[]} isLoading />}

      {status === 'error' && (
        <Typography color='error'>
          Something went wrong loading this feed&apos;s tags
        </Typography>
      )}
    </>
  );
};

export default PurposeIntentList;
